import Extension from "../base/extension";
import { convertSchemaToHtml } from '@thebeyondgroup/shopify-rich-text-renderer';

class MetaobjectUtilities extends Extension {
  constructor(name) {
    super(name);

    Stencil.registerHelper("getMetaobjects", this.#getMetaobjects, this);
  }

  async #getMetaobjects(type, sortField = 'handle') {
    const query = `
      query MetaobjectsQuery($after: String) {
        metaobjects(type: "${type}", first: 50, after: $after) {
          nodes {
            id
            handle
            fields {
              key
              value
              type
              reference {
                ... on MediaImage {
                  image {
                    url(transform: { maxWidth: 400 })
                    id
                    height
                    width
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;
    let metaobjects = await Stencil.Helpers.getAllNodes(query);

    metaobjects.forEach(metaobject => {
      metaobject.fields.forEach(field => {
        switch(field.type) {
          case "rich_text_field":
            field.resolved_value = convertSchemaToHtml(JSON.parse(field.value));
            break;
          case "file_reference":
            field.resolved_value = field.reference.image.url;
            break;
          case "boolean":
            field.resolved_value = (field.value === 'true');
            break;
          default:
            field.resolved_value = field.value;
        }
      });
    });

    // Add a key-value map of fields to each metaobject
    const transformedMetaobjects = metaobjects.map(obj => ({
      ...obj,
      fields_keyed: obj.fields.reduce((acc, field) => {
        acc[field.key] = field;
        return acc;
      }, {})
    }));

    // Natural sort based on sortField
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    const sortedMetaobjects = transformedMetaobjects.sort((a, b) => 
      collator.compare(a.fields_keyed[sortField].resolved_value, b.fields_keyed[sortField].resolved_value)
    );

    return sortedMetaobjects;
  }
}

export default MetaobjectUtilities;